import { Component, HostBinding, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PurchaseFormService } from '../../../../services/purchase-form.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-terms-card',
    templateUrl: './terms-card.component.html',
    styleUrls: ['./terms-card.component.css'],
    standalone: true,
    imports: [
    FormsModule,
    TranslateModule
],
})
export class TermsCardComponent implements OnInit {
    termsAccepted: boolean = false;

    constructor(private translateService: TranslateService, private formService: PurchaseFormService) { }

    ngOnInit(): void {
        this.termsAccepted = this.formService.getTermsAccepted();
    }

    @HostBinding('class.is-checked') get isChecked() {
        return this.termsAccepted;
    }

    onTermsChange(): void {
        this.formService.setTermsAccepted(this.termsAccepted);
    }

    onViewLink(translationKey: string): void {
        const url = this.translateService.instant(translationKey);
        if (url) {
            window.open(url, '_blank');
        }
    }

}
